<app-app-nav></app-app-nav>

<main id="mainContent" tabindex="-1">

  <!-- HERO -->
  <section class="eqac-hero position-relative">
    <div class="eqac-hero-bg">
      <img [src]="data?.CONSTRUCTION_IMG_PATH" alt="" />
      <div class="eqac-hero-overlay"></div>
    </div>
    <div class="eqac-hero-inner container-fluid">
      <span class="eqac-type-badge" *ngIf="has(data?.TYPE_TITLE)">{{data?.TYPE_TITLE}}</span>
      <h1 class="eqac-hero-title heading-font">
        <img class="eqac-hero-logo" *ngIf="has(data?.CONSTRUCTION_LOGO)" [src]="data?.CONSTRUCTION_LOGO" alt="" />
        <span>{{data?.CONSTRUCTION_NAME || 'مركز ضمان الجودة'}}</span>
      </h1>
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item"><a class="text-white" routerLink="/">أكاديمية الفنون</a></li>
          <li class="breadcrumb-item active text-white" aria-current="page">{{data?.CONSTRUCTION_NAME || 'مركز ضمان الجودة'}}</li>
        </ol>
      </nav>
    </div>
  </section>

  <!-- TAB NAV -->
  <nav class="eqac-nav">
    <div class="container-fluid">
      <ul class="eqac-nav-list list-unstyled mb-0">
        <li><a role="button" tabindex="0" [class.active]="activeTab==='home'" (click)="setTab('home')" (keydown.enter)="setTab('home')" (keydown.space)="setTab('home')">الرئيسية</a></li>
        <li><a role="button" tabindex="0" [class.active]="activeTab==='about'" (click)="setTab('about')" (keydown.enter)="setTab('about')" (keydown.space)="setTab('about')">عن المركز</a></li>
        <li><a role="button" tabindex="0" [class.active]="activeTab==='activities'" (click)="setTab('activities')" (keydown.enter)="setTab('activities')" (keydown.space)="setTab('activities')">أنشطة المركز</a></li>
        <li><a role="button" tabindex="0" [class.active]="activeTab==='courses'" (click)="setTab('courses')" (keydown.enter)="setTab('courses')" (keydown.space)="setTab('courses')">الدورات التدريبية</a></li>
        <li><a role="button" tabindex="0" [class.active]="activeTab==='units'" (click)="setTab('units')" (keydown.enter)="setTab('units')" (keydown.space)="setTab('units')">الوحدات</a></li>
        <li><a role="button" tabindex="0" [class.active]="activeTab==='reviews'" (click)="setTab('reviews')" (keydown.enter)="setTab('reviews')" (keydown.space)="setTab('reviews')">زيارات المراجعة</a></li>
        <li><a role="button" tabindex="0" [class.active]="activeTab==='contact'" (click)="setTab('contact')" (keydown.enter)="setTab('contact')" (keydown.space)="setTab('contact')">تواصل معنا</a></li>
      </ul>
    </div>
  </nav>

  <div class="container-fluid eqac-body">

    <!-- ============ الرئيسية ============ -->
    <ng-container *ngIf="activeTab==='home'">
      <section class="eqac-section" *ngIf="section('دور') as s">
        <div class="eqac-heading"><span class="eqac-heading-accent"></span><h2 class="heading-font mb-0">{{s.NAME}}</h2></div>
        <p class="eqac-text" *ngIf="has(s.DESCRIPTION)">{{s.DESCRIPTION}}</p>
      </section>

      <section class="eqac-section" *ngIf="section('الاهداف') as s">
        <div class="eqac-heading"><span class="eqac-heading-accent"></span><h2 class="heading-font mb-0">{{s.NAME}}</h2></div>
        <p class="eqac-text" *ngIf="has(s.DESCRIPTION)">{{s.DESCRIPTION}}</p>
        <ul class="eqac-list" *ngIf="s.itemsList?.length">
          <li *ngFor="let it of s.itemsList">{{it.NAME}}</li>
        </ul>
      </section>

      <section class="eqac-section" *ngIf="news?.length">
        <div class="eqac-heading"><span class="eqac-heading-accent"></span><h2 class="heading-font mb-0">أحدث الأخبار</h2></div>
        <div class="eqac-news-grid">
          <a class="eqac-news-card" *ngFor="let item of news" (click)="newsDetails(item)" role="button" tabindex="0" (keydown.enter)="newsDetails(item)" (keydown.space)="newsDetails(item)">
            <div class="eqac-news-media"><img [src]="item.IMG_PATH" [alt]="item.TITLE" loading="lazy" /></div>
            <div class="eqac-news-body">
              <span class="eqac-news-date">{{item.NEW_DATE | date:'yyyy/MM/dd'}}</span>
              <h3 class="eqac-news-title heading-font">{{item.TITLE}}</h3>
            </div>
          </a>
        </div>
      </section>
    </ng-container>

    <!-- ============ عن المركز ============ -->
    <ng-container *ngIf="activeTab==='about'">
      <div class="eqac-subnav">
        <a role="button" tabindex="0" [class.active]="aboutTab==='about'" (click)="aboutTab='about'" (keydown.enter)="aboutTab='about'" (keydown.space)="aboutTab='about'">عن المركز</a>
        <a role="button" tabindex="0" [class.active]="aboutTab==='management'" (click)="aboutTab='management'" (keydown.enter)="aboutTab='management'" (keydown.space)="aboutTab='management'">إدارة المركز</a>
      </div>

      <!-- عن المركز -->
      <ng-container *ngIf="aboutTab==='about'">
        <!-- كلمة مدير المركز -->
        <section class="eqac-section" *ngIf="has(data?.ACT_PERSON_WORD) || section('كلمه مدير')">
          <div class="eqac-heading"><span class="eqac-heading-accent"></span><h2 class="heading-font mb-0">كلمة مدير المركز</h2></div>
          <div class="eqac-head-card">
            <img class="eqac-head-photo" *ngIf="has(data?.ACT_PERSON_IMG)" [src]="data?.ACT_PERSON_IMG" [alt]="data?.ACT_PERSON_NAME" />
            <div class="eqac-head-body">
              <h4 class="eqac-head-name" *ngIf="has(data?.ACT_PERSON_NAME)">{{data?.ACT_PERSON_NAME}}</h4>
              <span class="eqac-head-role">مدير مركز ضمان الجودة</span>
              <p class="eqac-head-word" *ngIf="has(data?.ACT_PERSON_WORD)"><span class="quote-mark">“</span>{{data?.ACT_PERSON_WORD}}</p>
              <p class="eqac-text" *ngFor="let it of section('كلمه مدير')?.itemsList">{{it.NAME}}</p>
            </div>
          </div>
        </section>

        <!-- نبذة عن المركز -->
        <section class="eqac-section" *ngIf="has(data?.CONSTRUCTION_ABOUT)">
          <div class="eqac-heading"><span class="eqac-heading-accent"></span><h2 class="heading-font mb-0">نبذة عن المركز</h2></div>
          <p class="eqac-text">{{data?.CONSTRUCTION_ABOUT}}</p>
        </section>

        <!-- الرؤية والرسالة (بستايل الهوية) -->
        <section class="eqac-section" *ngIf="visionSection || missionSection">
          <ul class="eqac-identity list-unstyled mb-0">
            <li class="eqac-identity-item" *ngIf="visionSection as v">
              <span class="eqac-identity-num heading-font">01</span>
              <div class="eqac-identity-body">
                <h3 class="heading-font eqac-identity-title">الرؤية</h3>
                <p class="eqac-text mb-0" *ngIf="has(v.DESCRIPTION)">{{v.DESCRIPTION}}</p>
              </div>
            </li>
            <li class="eqac-identity-item" *ngIf="missionSection as m">
              <span class="eqac-identity-num heading-font">02</span>
              <div class="eqac-identity-body">
                <h3 class="heading-font eqac-identity-title">الرسالة</h3>
                <p class="eqac-text mb-0" *ngIf="has(m.DESCRIPTION)">{{m.DESCRIPTION}}</p>
              </div>
            </li>
          </ul>
        </section>

        <!-- الأقسام النصية: دور / أهداف / مهام -->
        <section class="eqac-section">
          <div class="eqac-cards-grid">
            <div class="eqac-detail-card" *ngFor="let s of aboutSections">
              <h3 class="eqac-card-title heading-font">{{s.NAME}}</h3>
              <p class="eqac-text" *ngIf="has(s.DESCRIPTION)">{{s.DESCRIPTION}}</p>
              <ul class="eqac-list" *ngIf="s.itemsList?.length">
                <li *ngFor="let it of s.itemsList">{{it.NAME}}</li>
              </ul>
            </div>
          </div>
        </section>

        <!-- ألبوم الصور -->
        <section class="eqac-section" *ngIf="gallery?.length">
          <div class="eqac-heading"><span class="eqac-heading-accent"></span><h2 class="heading-font mb-0">ألبوم الصور</h2></div>
          <div class="eqac-gallery-grid">
            <div class="eqac-gallery-item" *ngFor="let g of gallery"><img [src]="g.image_path" loading="lazy" alt="" /></div>
          </div>
        </section>
      </ng-container>

      <!-- إدارة المركز -->
      <ng-container *ngIf="aboutTab==='management'">
        <section class="eqac-section" *ngFor="let s of managementSections">
          <div class="eqac-heading"><span class="eqac-heading-accent"></span><h2 class="heading-font mb-0">{{s.NAME}}</h2></div>
          <p class="eqac-text" *ngIf="has(s.DESCRIPTION)">{{s.DESCRIPTION}}</p>
          <ul class="eqac-members" *ngIf="s.itemsList?.length">
            <li *ngFor="let it of s.itemsList">{{it.NAME}}</li>
          </ul>
        </section>
        <div class="eqac-empty" *ngIf="!managementSections.length">لا توجد بيانات إدارة متاحة حاليًا.</div>
      </ng-container>
    </ng-container>

    <!-- ============ الوحدات ============ -->
    <ng-container *ngIf="activeTab==='units'">
      <section class="eqac-section">
        <div class="eqac-heading"><span class="eqac-heading-accent"></span><h2 class="heading-font mb-0">وحدات ضمان الجودة — القاهرة</h2></div>
        <div class="eqac-units-grid">
          <div class="eqac-unit-card" *ngFor="let u of cairoUnits"><i class="eqac-unit-dot"></i><span>{{u}}</span></div>
        </div>
      </section>
      <section class="eqac-section">
        <div class="eqac-heading"><span class="eqac-heading-accent"></span><h2 class="heading-font mb-0">وحدات ضمان الجودة — فرع الإسكندرية</h2></div>
        <div class="eqac-units-grid">
          <div class="eqac-unit-card" *ngFor="let u of alexUnits"><i class="eqac-unit-dot"></i><span>{{u}}</span></div>
        </div>
      </section>
    </ng-container>

    <!-- ============ تواصل معنا ============ -->
    <ng-container *ngIf="activeTab==='contact'">
      <section class="eqac-section">
        <div class="eqac-heading"><span class="eqac-heading-accent"></span><h2 class="heading-font mb-0">تواصل معنا</h2></div>
        <div class="eqac-social" *ngIf="has(data?.CONSTRUCTION_FACEBOOK) || has(data?.CONSTRUCTION_TWITTER) || has(data?.CONSTRUCTION_INSTAGRAME) || has(data?.CONSTRUCTION_YOUTUBE)">
          <a *ngIf="has(data?.CONSTRUCTION_FACEBOOK)" [href]="data?.CONSTRUCTION_FACEBOOK" target="_blank" rel="noopener" class="eqac-social-btn">فيسبوك</a>
          <a *ngIf="has(data?.CONSTRUCTION_INSTAGRAME)" [href]="data?.CONSTRUCTION_INSTAGRAME" target="_blank" rel="noopener" class="eqac-social-btn">إنستغرام</a>
          <a *ngIf="has(data?.CONSTRUCTION_TWITTER)" [href]="data?.CONSTRUCTION_TWITTER" target="_blank" rel="noopener" class="eqac-social-btn">تويتر</a>
          <a *ngIf="has(data?.CONSTRUCTION_YOUTUBE)" [href]="data?.CONSTRUCTION_YOUTUBE" target="_blank" rel="noopener" class="eqac-social-btn">يوتيوب</a>
        </div>
      </section>
      <section class="eqac-section">
        <div class="eqac-heading"><span class="eqac-heading-accent"></span><h2 class="heading-font mb-0">روابط هامة</h2></div>
        <ul class="eqac-links">
          <li *ngFor="let l of importantLinks">
            <a *ngIf="l.url" [href]="l.url" target="_blank" rel="noopener">{{l.name}}</a>
            <span *ngIf="!l.url">{{l.name}}</span>
          </li>
        </ul>
      </section>
    </ng-container>

    <!-- ============ تبويبات في انتظار الـ API ============ -->
    <ng-container *ngIf="activeTab==='activities' || activeTab==='courses' || activeTab==='reviews'">
      <section class="eqac-section">
        <div class="eqac-heading">
          <span class="eqac-heading-accent"></span>
          <h2 class="heading-font mb-0">
            <ng-container [ngSwitch]="activeTab">
              <span *ngSwitchCase="'activities'">أنشطة المركز</span>
              <span *ngSwitchCase="'courses'">الدورات التدريبية</span>
              <span *ngSwitchCase="'reviews'">زيارات المراجعة</span>
            </ng-container>
          </h2>
        </div>
        <div class="eqac-empty">
          <svg viewBox="0 0 24 24" width="46" height="46" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round">
            <rect x="3" y="4" width="18" height="18" rx="2" /><path d="M16 2v4M8 2v4M3 10h18" />
          </svg>
          <h3>المحتوى قيد الإضافة</h3>
          <p>سيتم عرض هذا القسم فور توفّر بياناته.</p>
        </div>
      </section>
    </ng-container>

  </div>
</main>
